// import material from 'vue-material/material'
// import MdIcon from 'components/MdIcon'
import MdSelect from './MdSelect';
import MdField from './MdField.vue';
import MdFile from './MdFile/MdFile.vue';
import MdInput from './MdInput/MdInput.vue';
import MdTextarea from './MdTextarea/MdTextarea.vue';
import { App } from 'vue';
// export default Vue => {
//   // material(Vue)
//   // Vue.use(MdIcon)s
//   // Vue.use(MdSelect)
//   Vue.component(MdField.name, MdField)
//   Vue.component(MdFile.name, MdFile)
//   Vue.component(MdInput.name, MdInput)
//   Vue.component(MdTextarea.name, MdTextarea)
// }

export const registerMdField = (app: App) => {
  app.component(MdField.name ?? 'MdField', MdField);
  app.component(MdFile.name ?? 'MdFile', MdFile);
  app.component(MdInput.name ?? 'MdInput', MdInput);
  app.component(MdTextarea.name ?? 'MdTextarea', MdTextarea);
};
